import React, { propTypes } from 'react';
import { SpaceShape } from 'venuescanner-js/react/shapes';
import countries from 'venuescanner-js/constants/countries.json';

const Pricing = ({ space }) => {
  const { is_daily: isDaily } = space;
  const venueCountry = space.country_code;

  const prices = [
    isDaily &&
      space.price_hourly && [
        `${venueCountry ? countries[venueCountry].currency.symbol : '£'}${
          space.price_hourly
        }`,
        'per hour',
      ],
    isDaily &&
      space.price_daily && [
        `${venueCountry ? countries[venueCountry].currency.symbol : '£'}${
          space.price_daily
        }`,
        'per day',
      ],
  ].filter(Boolean);

  if (space.is_per_guest && prices.length < 2) {
    prices.push([
      `${venueCountry ? countries[venueCountry].currency.symbol : '£'}${
        space.price_guest
      }`,
      'per guest',
    ]);
  }

  if (space.is_min && prices.length < 2) {
    prices.push([
      `${venueCountry ? countries[venueCountry].currency.symbol : '£'}${
        space.price_min
      }`,
      'min spend',
    ]);
  }

  if (space.is_poa && prices.length === 0) {
    prices.push(['POA', 'price on asking']);
  }

  return (
    <div className='space-tile__price'>
      <div className='space-tile__price__info'>
        {prices.map(([value, label], i) => (
          <div
            className={`factors-${prices.length} ${label.replace(/ /g, '-')}`}
            key={i}>
            {value}
            <span> {label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

Pricing.propTypes = {
  space: SpaceShape.isRequired,
};

export default Pricing;
